<template>
  <div class="UpdateSettings">
    <v-tabs vertical class="justify-right">
      <v-tab href="#DBUpdate" class="justify-right">
        <v-icon> mdi-database-refresh </v-icon>
        <span v-if="$vuetify.breakpoint.smAndUp"> بروزرسانی پایگاه داده </span>
      </v-tab>
      <!-- <v-tab
        href="#LockActivation"
        class="justify-right"
        :disabled="!LockActivationEnabled"
      >
        <v-icon> mdi-lock </v-icon>
        <span v-if="$vuetify.breakpoint.smAndUp"> فعال سازی قفل </span>
      </v-tab>

      <v-tab
        :disabled="!LockDeactivationEnabled"
        href="#LockDeactivation"
        class="justify-right"
      >
        <v-icon> mdi-lock-open-variant </v-icon>
        <span v-if="$vuetify.breakpoint.smAndUp"> غیر فعال سازی قفل </span>
      </v-tab> -->

      <v-tab-item value="DBUpdate">
        <div class="pa-3">
          <update-db />
        </div>
      </v-tab-item>

      <!-- <v-tab-item value="LockActivation">
        <div class="pa-3">
          <active-lock @RefreshTabs="RefreshTabs"/>
        </div>
      </v-tab-item>

      <v-tab-item value="LockDeactivation">
        <div class="pa-3">
          <deactive-lock @RefreshTabs="RefreshTabs"/>
        </div>
      </v-tab-item> -->
    </v-tabs>
  </div>
</template>

<script>
//import ActiveLock from "./ActiveLock.vue";
//import DeactiveLock from "./DeactiveLock.vue";
import UpdateDb from "./UpdateDb.vue";
export default {
  components: { UpdateDb,  },
  props: { LockActivationEnabled: Boolean, LockDeactivationEnabled: Boolean },
  data() {
    return {};
  },
  methods:{
    RefreshTabs(){
      this.$emit('RefreshTabs')
    }
  }
};
</script>

<style>
.BasicSystemSettings .v-tabs-bar {
  border: 0.15rem solid #f2f2f2;
  padding: 0.5rem;
}
</style>